import React from 'react';
/* --- import Components ----*/
import { CardMoreInfos } from 'src/components/Bootcamp';
import { Section } from '../Section';
import { SectionSubtitle } from '../Typography';
/* --- import Styles  ----*/
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const QuestionCTA = React.memo(({ bootcampLayout, fromFormationsPage }) => {
  const cardsInfos = [
    { title: 'Financements', link: '/financements' },
    { title: 'Questions fréquentes', link: '/faq/' },
    { title: 'Contactez-nous', link: '/contact/' },
    { title: "Modalités d'accès", link: '/modalites-d-acces/' },
  ];

  // UPDATE DATE
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, '0');
  let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  let yyyy = today.getFullYear();
  today = dd + '/' + mm + '/' + yyyy;

  const lastUpdateSentence = `Dernière mise à jour de cette page : le ${today}`;

  //

  return (
    <Section
      theme={fromFormationsPage === 'full-stack' ? 'secondary' : 'light'}
      css={{
        [mediaQueries.tabletLandscapeUp]: {
          paddingTop: bootcampLayout ? 279 : 110,
        },
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          [mediaQueries.tabletLandscapeUp]: {
            paddingBottom: 20,
          },
          [mediaQueries.phoneOnly]: {
            textAlign: 'center',
          },
        }}
      >
        <SectionSubtitle>Un renseignement supplémentaire&nbsp;?</SectionSubtitle>
        <div
          css={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            flex: 1,
            flexWrap: 'wrap',
            marginTop: 70,
            [mediaQueries.tabletPortraitUp]: {
              width: 500,
            },
            [mediaQueries.tabletLandscapeUp]: {
              width: 700,
            },
            [mediaQueries.desktopUp]: {
              width: 700,
            },
            [mediaQueries.mediumDesktopUp]: {
              width: '100%',
            },
            [mediaQueries.phoneOnly]: {
              marginTop: 30,
            },
          }}
        >
          {cardsInfos.map((card) => {
            if (fromFormationsPage === 'full-stack' && card.title === 'Questions fréquentes') {
              return null;
            } else {
              return (
                <CardMoreInfos
                  key={card.title}
                  title={card.title}
                  link={card.link}
                  fromFormationsPage={fromFormationsPage}
                />
              );
            }
          })}
        </div>
        {lastUpdateSentence ? (
          <div
            css={{
              marginTop: 70,
              fontSize: 17,
              color: colors.purpleDark,
              [mediaQueries.phoneOnly]: {
                fontSize: 14,
              },
            }}
          >
            {lastUpdateSentence}
          </div>
        ) : (
          ''
        )}
      </div>
    </Section>
  );
});
export default QuestionCTA;
